/**
 * Punctuate a sentence with a period. If it already ends with some kind of
 * punctuation, it is not punctuated. A sentence is a string of words that ends
 * in some kind of punctuation.
 *
 * @param sentence - The sentence to punctuate.
 * @returns The punctuated sentence.
 */
export const punctuateSentenceWithPeriod = (sentence: string): string => {
  if (!sentence || sentence.match(/[\\.:;!?\n]$/)) return sentence;
  return `${sentence}.`;
};
